'use strict';
import BasePreprocessor from './BasePreprocessor';

export default class ColumnSearchPreprocessor extends BasePreprocessor {
	constructor($q, searchQueryService) {
		super();
		this.$q = $q;
		this.searchQueryService = searchQueryService;

		this._conditions = {
			Conditions: [],
			Groups: [],
			LogicalOperator: mx.SolutionBuilderAgent.SearchQueryLogicalOperator.AND,
		};

		Object.defineProperty(this, 'conditions', {
			get: function () {
				return this._conditions;
			},
		});
	}

	init(executor) {
		this.executor = executor;

		Object.defineProperty(this, 'columnsObject', {
			get: function () {
				return executor.notPersonalizedColumns || {};
			},
		});
	}

	setColumnConditions(newConditions) {
		if (!Array.isArray(newConditions) || angular.equals(this._conditions, newConditions)) {
			return;
		}

		return this.$q
			.all(
				newConditions.map(function (con) {
					return this.searchQueryService.createConditionByColumn(con.field, this.executor.dataQuery).then(function (condition) {
						condition.operator = con.operator;
						condition.value = con.value;

						return condition;
					});
				}, this)
			)
			.then(
				function (conditions) {
					this._conditions.Conditions = conditions;

					if (this.executor.preprocessors.pagingPreprocessor) {
						this.executor.preprocessors.pagingPreprocessor.page = 0;
					}
					this.changed();
				}.bind(this)
			);
	}
}
ColumnSearchPreprocessor.$inject = ['$q', 'mx.SolutionBuilderAgent.SearchQueryService'];
